// What's New: the contract between the Discover API and the front end ("What's New API contract",
// 2026-09-30). The back end decides, the front end renders: the customer routes only ever return
// `NotificationItem`, with the button already resolved. Every message is the one template the API
// knows, "announcement_card": its words, colours and picture come in `content`, and the front end
// draws it as a card with no words of its own (`ANNOUNCEMENT_CARD_DIALOG`). A picture shows only when
// the announcement has one.
/** The API's only template. */
const ANNOUNCEMENT_CARD_TEMPLATE = "announcement_card";

export { ANNOUNCEMENT_CARD_TEMPLATE };
